import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueI18n from 'vue-i18n';
import echarts from './utils/echarts.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/el-element.css'
import i18n from './common/lang';
// import enLocale from 'element-ui/lib/locale/lang/en';
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false

function decodeBase64Utf8(value) {
  const binary = window.atob(value);
  const encoded = Array.prototype.map.call(binary, char => {
    const hex = char.charCodeAt(0).toString(16).padStart(2, '0');
    return '%' + hex;
  }).join('');
  return decodeURIComponent(encoded);
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function upsertMetaTag(name, content) {
  let meta = document.querySelector('meta[name="' + name + '"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function applyDynamicMeta() {
  const encoded = '5oKf56m65rqQ56CB572RIHd1a29uZ3ltdy5jb20gd3Vrb25neW13Lm5ldCB3dWtvbmd5bXcudmlwIFRH77yaQHd1a29uZ3ltdw==';
  const decoded = escapeHtml(decodeBase64Utf8(encoded));
  upsertMetaTag('keywords', decoded);
  upsertMetaTag('description', decoded);
}

applyDynamicMeta();
/** 国际化 **/
// Vue.use(VueI18n);
// Vue.use(ElementUI, {
//   i18n: (key, value) => i18n.t(key, value)
// });
// const i18n = new VueI18n({
//   locale: 'en',
//   messages: {
//     'zh': Object.assign(require('@/common/lang/zh'), zhLocale),
//     'en': Object.assign(require('@/common/lang/en'), enLocale),
//   }
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')